import React from "react";
import {
  BarChart3, TrendingUp, Gauge, Sparkles, Target, ShieldCheck,
  Archive, Swords, Lightbulb, Building2, BookMarked, LayoutDashboard, KeyRound,
} from "lucide-react";

export const MODULES = [
  { key: "m0",         icon: LayoutDashboard, label: "Cuadro de Mando",       sub: "M0 · Resumen ejecutivo" },
  { key: "market",     icon: BarChart3,  label: "Market & Bid Universe", sub: "M1 · Mapa del mercado" },
  { key: "pipeline",   icon: TrendingUp, label: "Pipeline ponderado",     sub: "M2 · Forecast" },
  { key: "accounts",   icon: Building2,  label: "CRM Pre-Tender",         sub: "M3 · 360º Accounts" },
  { key: "historic",   icon: Archive,    label: "Historic Tender DB",     sub: "M4 · Biblioteca" },
  { key: "bpai",       icon: Lightbulb,  label: "BidAI Knowledge",        sub: "M5 · Best Practices" },
  { key: "competitive",icon: Swords,     label: "Competitive Intel",      sub: "M6 · Rivales" },
  { key: "postmortem", icon: BookMarked, label: "Post-Mortem Roadmap",    sub: "M7 · Lecciones" },
  { key: "viability",  icon: Gauge,      label: "Go / No-Go Pando",          sub: "M8 · Viabilidad" },
  { key: "writing",    icon: Sparkles,   label: "Bid Writing Hub",        sub: "M9 · Redacción Pando" },
  { key: "keywords",   icon: KeyRound,   label: "Keywords Pando",            sub: "Scraper · Palabras clave" },
];

// Iter307 · G06 — mismas fechas ISO sin formatear que en Ofertas Comercial;
// se normaliza a DD/MM/AAAA (es-ES) para no mostrar "2026-09-28T14:00:00" en pantalla.
export function fmtFechaOferta(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export const ESTADO_LABELS = {
  identificada: "Identificada",
  en_analisis: "En análisis",
  oferta_preparacion: "Preparando oferta",
  oferta_presentada: "Presentada",
  adjudicada: "Adjudicada",
  desestimada: "Desestimada",
  no_presentada: "No presentada",
  ganada: "Ganada",
};

export const ESTADO_CLS = {
  identificada:       "bg-gray-100 text-gray-700",
  en_analisis:        "bg-indigo-100 text-indigo-700",
  oferta_preparacion: "bg-amber-100 text-amber-700",
  oferta_presentada:  "bg-blue-100 text-blue-700",
  adjudicada:         "bg-green-100 text-green-700",
  ganada:             "bg-green-100 text-green-700",
  desestimada:        "bg-rose-100 text-rose-700",
  no_presentada:      "bg-stone-100 text-stone-500",
};

export const fmtEur = (n) => n == null ? "—" : new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export function Field({ label, children, span = 1 }) {
  return (
    <div className={span === 2 ? "col-span-2" : ""}>
      <div className="text-[10px] uppercase font-bold text-gray-500 tracking-wide mb-0.5">{label}</div>
      {children}
    </div>
  );
}

export function Kpi({ label, val }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-3">
      <div className="text-[10px] text-gray-500 uppercase font-semibold tracking-wide">{label}</div>
      <div className="text-lg font-bold text-gray-900 mt-1">{val}</div>
    </div>
  );
}
